export interface ContractStore {
    error?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    response?: Contract[];
    search: (value:number/*, userService:string*/) =>  Promise<void>;
}
export interface Contract {
    projectId: number
    projectKey:string
    projectName: string
    projectSupervisorEmail: string
    customerId: number
    customerName: string
    projectStateLabel: string
    serviceName: string
    serviceId:number
    startDate:Date
    projectSalesRepresentativeEmail: string
}

export interface ContractStatusStore {
    error?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseStatus?: ContractStatus[];
    searchStatus: (value:number) =>  Promise<void>;
}

export interface AddContractStatusStore {
    error?: string;
    isLoading?: boolean;
    isFinished?: boolean;
    responseAddedItem?: ContractStatus;
    addStatus: (value:number, projectStatus: Status) =>  Promise<void>;
}

export interface ContractStatus {
    id_iovision: number;
    status: Status;
    created: string;
    created_by: string;
    updated: string;
    updated_by: string;
}


export enum Status {
  CREER = "CREER",
  ARCHIVER = "ARCHIVER",
  RESTAURER = "RESTAURER",
}